import type { AreaCatalog } from '../area';
import type { legacy as en } from '../en/legacy';

export const legacy = {
  'legacy.statement.deliveredWaitsOnRequester':
    'Fertig; wartet auf den Abschluss durch die Verantwortlichen.',
  'legacy.statement.seatedDeliveredWaitsOnRequester':
    'Ist jetzt zuständig; fertig, wartet auf den Abschluss durch die Verantwortlichen.',
  'legacy.statement.deliveredClosesOnReview':
    'Fertig; wird abgeschlossen, sobald die Abnahme vorliegt.',
  'legacy.statement.deliveredClosesWithSubTasks': {
    one: 'Fertig; wird abgeschlossen, sobald die {count} Unteraufgabe abgeschlossen ist.',
    other: 'Fertig; wird abgeschlossen, sobald die {count} Unteraufgaben abgeschlossen sind.',
  },
  'legacy.statement.subTasksDoneClosing':
    'Die Unteraufgaben sind erledigt: wird wie vorgemerkt abgeschlossen.',
  'legacy.statement.reviewLandedClosing':
    'Die Abnahme liegt vor: wird wie vorgemerkt abgeschlossen.',
  'legacy.statement.withLockedStaying': {
    one: '{statement} {count} bleibt offen.',
    other: '{statement} {count} bleiben offen.',
  },
} as const satisfies AreaCatalog<typeof en>;
